/* global moment, Highcharts, pluralize */

(function () {
  'use strict';

  var id = 'essentials';
  var demo = false;
  angular.module('wsLrs.cards').config(['$routeProvider', function ($routeProvider) {
    // Add routes
    $routeProvider.
    //route format MUST be: card.template.name + "/" + card.id
    when('/essentials', {
      templateUrl: 'modules/app/essentials/essentials.html',
      controller: id + '.Ctrl',
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }],
        hasInteractions: ['Interactions', function (Interactions) {
          return Interactions.hasAny();
        }]
      }
    });
  }]).factory(id + '.Utils', ['CardQueryResource', 'wsColors', '$filter', 'Api', '$http', '$q', function (CardQueryResource, wsColors, $filter, Api, $http, $q) {
    var self = {
      getStatementCount: function getStatementCount(filter) {
        return CardQueryResource.get("essentials/count", null, {
          filter: filter,
          demo: demo
        }, null, id + "-count");
      },
      getPersonDetails: function getPersonDetails(filter, personId) {
        return CardQueryResource.get("essentials/person", null, {
          filter: filter,
          personId: personId,
          demo: demo
        }, null, "person_" + (personId ? personId : "all"));
      },
      getActivityProviders: function getActivityProviders() {
        if (demo) {
          return $q.resolve({
            count: 0
          });
        } else {
          return $http.get(Api.url("/activity-providers"));
        }
      },
      getActivityDetails: function getActivityDetails(filter, activityId, type) {
        return CardQueryResource.get("essentials/activity", null, {
          filter: filter,
          activityId: activityId,
          type: type,
          demo: demo
        }, null, "activity_" + (activityId ? activityId : "all"));
      },
      fetchData: function fetchData(filter, countOnly) {
        return $q.all([CardQueryResource.get("essentials/overview", null, {
          filter: filter,
          countOnly: countOnly,
          order_by: "-measure[0].value",
          _limit: 5,
          demo: demo
        }, null, id + "-overview"), CardQueryResource.get("essentials/counts-by-day", null, {
          filter: filter,
          demo: demo
        }, null, id + "-overview")]).then(function (responses) {
          // Merge counts-by-day results into essentials/overview
          var overviewResults = responses[0].data.results;
          var i = _.size(overviewResults);
          _.each(responses[1].data.results, function (res) {
            overviewResults[i] = res;
            i = i + 1;
          });
          return responses[0];
        });
      },
      fetchEntityData: function fetchEntityData(entity, filter, sort, limit, offset) {
        var ent = pluralize(entity);
        return CardQueryResource.get("essentials/" + ent, null, {
          filter: filter,
          order_by: sort,
          _limit: limit,
          _offset: offset,
          demo: demo
        }, null);
      },
      getCounts: function getCounts(response) {
        return {
          dataSources: response.results[0].result.count,
          activities: response.results[1].result.count,
          people: response.results[2].result.count,
          actions: response.results[3].result.count,
          results: response.results[4].result.count
        };
      },
      getList: function getList(data, key, agg_i) {
        agg_i = agg_i || 0;
        return _.map(data, pluralize(key) === 'actions' ? function (d) {
          return {
            //actions get a combined label from dimension 0 and 1
            id: d.values[0].value,
            name: d.values[0].label,
            title: d.values[0].label,
            count: d.aggregations[agg_i].value,
            type: key
          };
        } : function (d) {
          return {
            id: d.values[0].value,
            name: d.values[0].label || d.values[0].value,
            title: d.values[0].label || d.values[0].value,
            count: d.aggregations[agg_i].value,
            type: key
          };
        });
      },
      getLists: function getLists(response) {
        var res = {};
        _.each(['dataSources', 'activities', 'people', 'actions', 'results'], function (key, i) {
          res[key] = self.getList(response.results[i].result.data, key);
        });
        return res;
      },
      getPercentChange: function getPercentChange(from, to) {
        return from && _.isNumber(to) ? (to - from) * 100 / from : null;
      },
      createDataSourceFilter: function createDataSourceFilter(d) {
        var filter = {};
        if (d.id === 'ALL') {
          return filter;
        }
        var vals = d.id.split('[,]');
        if (vals[0] === 'authority.account') {
          var account = vals[1].split('[:]');
          filter.equals = [
          //we do not use the home page because the equals filter creates an OR filter
          // so any authorities that share a homepage (as many do) are all grouped
          {
            fieldName: vals[0] + '.name',
            values: {
              ids: [account[1]]
            }
          }];
        } else {
          filter.equals = [{
            fieldName: vals[0],
            values: {
              regExp: vals[1].indexOf('.*') > 0,
              ids: [vals[1]]
            }
          }];
        }
        return filter;
      },
      addEntityToFilter: function addEntityToFilter(filter, entity) {
        if (!entity.type) {
          return filter;
        }
        switch (entity.type) {
          case 'people':
          case 'person':
            filter.personIds = filter.personIds || [];
            filter.personIds.push(entity.id || entity.dbId);
            break;
          case 'actions':
          case 'action':
            var ids = entity.id.split(" + ");
            if (ids.length > 1) {
              filter.verbIds = filter.verbIds || {};
              filter.verbIds.ids = filter.verbIds.ids || [];
              filter.verbIds.ids.push(ids[0]);
              filter.activityIds = filter.activityIds || {};
              filter.activityIds.ids = filter.activityIds.ids || [];
              filter.activityIds.ids.push(ids[1]);
            }
            break;
          case 'activities':
          case 'activity':
          case 'results':
          case 'result':
            filter.activityIds = filter.activityIds || {};
            filter.activityIds.ids = filter.activityIds.ids || [];
            if (entity.id) {
              filter.activityIds.ids.push(entity.id);
            }
            break;
          default:
        }
        return filter;
      },
      getDateFilters: function getDateFilters(currentFilter) {
        currentFilter = currentFilter || {};
        var dateFilters = [{
          name: 'All data',
          start: null,
          end: null
        }, {
          name: 'Today',
          start: moment.utc().startOf('day'),
          end: moment.utc().endOf('day')
        }, {
          name: 'Yesterday',
          start: moment.utc().subtract(1, 'day').startOf('day'),
          end: moment.utc().subtract(1, 'day').endOf('day')
        }, {
          name: 'This week',
          start: moment.utc().startOf('week'),
          end: moment.utc().endOf('week')
        }, {
          name: 'Last week',
          start: moment.utc().subtract(1, 'week').startOf('week'),
          end: moment.utc().subtract(1, 'week').endOf('week')
        }, {
          name: 'This month',
          start: moment.utc().startOf('month'),
          end: moment.utc().endOf('month')
        }, {
          name: 'Last month',
          start: moment.utc().subtract(1, 'month').startOf('month'),
          end: moment.utc().subtract(1, 'month').endOf('month')
        }, {
          name: 'Last 30 days',
          start: moment.utc().subtract(30, 'day').startOf('day'),
          end: moment.utc().endOf('day')
        }, {
          name: 'This year',
          start: moment.utc().startOf('year'),
          end: moment.utc().endOf('year')
        }, {
          name: 'Last year',
          start: moment.utc().subtract(1, 'year').startOf('year'),
          end: moment.utc().subtract(1, 'year').endOf('year')
        }];
        return dateFilters;
      },
      getPreviousPeriod: function getPreviousPeriod(filter) {
        var name = '',
          numberOfPeriods = 1,
          period = '';
        if (filter.name === 'Today') {
          name = 'Yesterday';
          period = 'day';
        } else if (filter.name === 'Yesterday') {
          name = 'Previous day';
          period = 'day';
        } else if (filter.name.indexOf('This') === 0) {
          name = filter.name.replace(/^This/, 'Last');
          period = filter.name.replace(/^This /, '');
        } else if (filter.name.indexOf('Last') === 0) {
          name = filter.name.replace(/^Last/, 'Previous');
          period = filter.name.replace(/^Last /, '');
        }
        if (period === '30 days') {
          numberOfPeriods = 30;
          period = 'day';
        }
        return {
          name: name,
          start: filter.start && filter.start.clone().subtract(numberOfPeriods, period),
          end: filter.end && filter.end.clone().subtract(numberOfPeriods, period)
        };
      },
      getLastYearPeriod: function getLastYearPeriod(filter) {
        if (filter.name.indexOf('year')) {
          return null;
        }
        return {
          name: 'Last year',
          start: filter.start && filter.start.clone().subtract(1, 'year'),
          end: filter.end && filter.end.clone().subtract(1, 'year')
        };
      },
      getPieChart: function getPieChart(data) {
        var chart = {
          chart: {
            type: 'pie'
          },
          title: {
            text: null
          },
          tooltip: {
            shared: true,
            formatter: function formatter() {
              var tool = '<div class="watershed-tooltip" ><table><thead><tr><th></th></tr></thead>';
              tool += '<tr><td style="color:' + this.color + '">' + this.key + ':</td>';
              tool += '<td>' + this.y + ' (' + Math.round(this.percentage * 10) / 10 + '%)</td></tr>';
              tool += '</table></div>';
              return tool;
            }
          },
          plotOptions: {
            pie: {
              allowPointSelect: false,
              cursor: 'pointer',
              dataLabels: {
                enabled: false
              },
              showInLegend: true
            }
          },
          series: [{
            colorByPoint: true,
            data: _.map(data, function (d) {
              return {
                name: d.name,
                id: d.id,
                y: d.count
              };
            })
          }]
        };
        return chart;
      },
      pointWithDateExists: function pointWithDateExists(data, cfg) {
        var match = _.filter(data, function (point) {
          return moment.utc(point.x).isSame(cfg.date, 'day');
        });
        if (match.length > 0) {
          return true;
        } else {
          return false;
        }
      },
      getLineChart: function getLineChart(data, cfg) {
        var chart = {
          chart: {
            defaultSeriesType: 'area',
            borderWidth: 0,
            backgroundColor: '#fff',
            plotBackgroundColor: '#fff',
            alignTicks: false
          },
          credits: {
            enabled: false
          },
          title: {
            text: null,
            align: 'center'
          },
          legend: {
            enabled: false
          },
          tooltip: {
            shared: true,
            formatter: function formatter() {
              var tool = '<div class="watershed-tooltip" ><table><thead><tr><th>' + (this.points[0].point.dimensionName || '') + '</th></tr></thead>';
              _.each(this.points, function (p) {
                var y = Math.round(p.point.y * 100) / 100;
                tool += '<tr style="color:' + p.series.color + '"><td>' + p.series.name + ':</td>' + '<td>' + y + '</td></tr>';
              });
              tool += '</table></div>';
              return tool;
            }
          },
          plotOptions: {
            series: {
              shadow: false,
              connectNulls: true
            }
          },
          xAxis: {
            title: {
              text: null
            },
            offset: 6,
            type: 'datetime',
            labels: {
              formatter: function formatter() {
                return Highcharts.dateFormat("%b %e", this.value, true) + ",<br/>" + Highcharts.dateFormat("%Y", this.value, true);
              }
            },
            tickLength: 0,
            minorTickLength: 0,
            gridLineWidth: 1,
            showLastLabel: true,
            showFirstLabel: true,
            lineWidth: 0
          },
          yAxis: [{
            id: 'default',
            title: {
              rotation: -90,
              margin: 10,
              text: null
            },
            tickLength: 3,
            minorTickLength: 0,
            lineWidth: 1,
            gridLineWidth: 1
          }, {
            id: 'time',
            title: {
              rotation: -90,
              margin: 10,
              text: null
            },
            type: 'datetime',
            opposite: true,
            tickLength: 3,
            minorTickLength: 0,
            lineWidth: 1,
            gridLineWidth: 1,
            labels: {
              formatter: function formatter() {
                return $filter('compactTime')(this.value);
              }
            }
          }, {
            id: 'score',
            allowDecimals: false,
            title: {
              rotation: -90,
              margin: 10,
              text: null
            },
            opposite: true,
            max: 1,
            tickLength: 3,
            minorTickLength: 0,
            lineWidth: 1,
            gridLineWidth: 1,
            tickInterval: 0.1,
            labels: {
              formatter: function formatter() {
                return this.value * 100 + '%';
              }
            }
          }],
          series: [{
            name: cfg.name,
            data: []
          }]
        };
        var aggregationIndex = cfg.aggregationIndex || 0;
        _.each(data, function (d) {
          var day = moment.utc(d.values[0].value, 'YYYY-DDD');
          var s = chart.series[0];
          if (d.values.length > 1) {
            s = _.find(chart.series, function (a) {
              return a.id === d.values[1].value;
            });
            if (s === undefined) {
              if (cfg.include && cfg.include.indexOf(d.values[1].value) < 0) {
                //if we specified an array of ids to include skip the ones that are not in that array
                return;
              }
              chart.series.push({
                name: d.values[1].label || d.values[1].value,
                id: d.values[1].value,
                data: []
              });
              s = chart.series[chart.series.length - 1];
            }
          }
          s.data.push({
            x: day.toDate(),
            xMoment: day,
            y: d.aggregations[aggregationIndex].value,
            dimensionName: day.format("MMMM Do, YYYY")
          });
        });
        if (chart.series.length > 1) {
          chart.series.shift();
          if (chart.series.length > 1) {
            chart.legend.enabled = true;
          }

          //todo: stacking with datetime axis is bad
          // chart.plotOptions.area = {stacking: 'normal'};
        }
        _.each(chart.series, function (s) {
          if (s.data.length === 0) {
            return;
          }

          //sort data so highcharts is happy
          s.data = _.sortBy(s.data, 'x');
          var lastMoment = s.data[0].xMoment,
            oneDay = moment.duration(1, 'day') + moment.duration(1, 'hour');

          //this data is sorted already, so we look at the first and last data points
          //if the distance is greater than 3 months
          var weekScale = s.data[s.data.length - 1].xMoment.diff(s.data[0].x, 'months') >= 3;
          if (weekScale) {
            s.data = _.chain(s.data).groupBy(function (d) {
              //group into weeks using moments startOf function
              return d.xMoment.startOf('week').format();
            }).map(function (points, week) {
              //now we have all data points for that week
              week = moment.utc(week);
              //now we add up all the values
              var sum = _.reduce(points, function (memo, p) {
                return memo + p.y;
              }, 0);
              //and we return the final data point
              return {
                x: week.toDate(),
                y: sum,
                dimensionName: week.format("[Week of] MMMM Do, YYYY")
              };
            }).value();
            lastMoment = s.data[0].xMoment;
            oneDay = moment.duration(1, 'week') + moment.duration(1, 'hour');
          }

          // Fill gaps with zeroes
          for (var i = 0; i < s.data.length; i++) {
            if (s.data[i].xMoment - lastMoment > oneDay) {
              var currentMoment = moment.utc(lastMoment + oneDay);
              var upperBound = s.data[i].xMoment;
              while (currentMoment < upperBound) {
                s.data.splice(i, 0, {
                  x: currentMoment,
                  y: 0,
                  name: null,
                  dimensionName: currentMoment.format(weekScale ? "[Week of] MMMM Do, YYYY" : "MMMM Do, YYYY")
                });

                //adjust our index
                i++;
                currentMoment = moment.utc(currentMoment + oneDay);
              }
              --i;
            }
            lastMoment = s.data[i].xMoment;
          }
        });
        if (cfg.include) {
          chart.series = _.sortBy(chart.series, function (s) {
            return cfg.include.indexOf(s.id);
          });
        }
        return chart;
      }
    };
    return self;
  }]).controller('EssentialsDemoTourModalCtrl', ['$http', '$scope', '$uibModalInstance', '$timeout', 'Api', 'User', 'tourConfig', function ($http, $scope, $uibModalInstance, $timeout, Api, User, tourConfig) {
    var videoPrefix = "http://public.watershedlrs.com/videos/";
    $scope.slides = [{
      headline: "Watershed offers so much more than just an LRS. Here's where the magic happens."
    }, {
      headline: "Choose from an array of visualizations to tailor<br /> reports and dashboards.",
      video: videoPrefix + "Dashboards"
    }, {
      headline: "Use the report builder and measures to slice and dice your data any way you want.",
      video: videoPrefix + "ReportBuilder"
    }, {
      headline: "Embed visualizations where you know stakeholders can easily see them, email links to critical reports, and more.",
      video: videoPrefix + "ShareEmbed"
    }, {
      headline: "Get started with a scalable platform that’s enterprise ready and reflects your organization’s structure.",
      video: videoPrefix + "EnterpriseReady"
    }, {
      headline: "Reflect learning data alongside competencies, behavior,<br /> and organizational KPIs.",
      video: videoPrefix + "CompetenciesKPIs"
    }, {
      headline: "And that’s just the beginning.",
      video: videoPrefix + "AndMore"
    }];
    $scope.slideIndex = tourConfig.slide || 0;
    if ($scope.slideIndex < 0 || $scope.slideIndex >= $scope.slides.length) {
      $scope.slideIndex = 0;
    }
    $scope.nextSlide = function nextSlide() {
      var nextIndex = $scope.slideIndex + 1;
      if (nextIndex >= $scope.slides.length) {
        nextIndex = 0;
      }
      $scope.slideIndex = nextIndex;
    };
    $scope.previousSlide = function previousSlide() {
      var nextIndex = $scope.slideIndex - 1;
      if (nextIndex >= 0) {
        $scope.slideIndex = nextIndex;
      }
    };
    $scope.cancel = function cancel() {
      $uibModalInstance.close();
    };
    var user = User.get();
    if (user.organization && user.organization.id) {
      // Call WS API to track start demo event
      $http({
        method: 'POST',
        url: Api.url("analytics/essentials-demo-view", true),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: $.param({
          tenantId: user.organization.id
        })
      });
    }

    // NOTE: using jQuery here to avoid full-blown use of directive
    // for a specialized event handling case.
    $timeout(function () {
      $(".tour-content video").on('ended', $scope.$safeApply.bind($scope, function () {
        if ($scope.slideIndex !== 0) {
          $scope.nextSlide();
        }
      }));
    }, 250);
  }]).controller(id + '.Ctrl', ['$routeParams', '$scope', id + '.Utils', '$timeout', '$uibModal', 'hasInteractions', 'User', 'UserRoles', '$location', '$http', 'Api', 'Demo', 'OrganizationSettings', 'wsEventNames', '$rootScope', function ($routeParams, $scope, Utils, $timeout, $uibModal, hasInteractions, User, UserRoles, $location, $http, Api, Demo, OrganizationSettings, wsEventNames, $rootScope) {
    var essentialsTier = OrganizationSettings.getCachedPricingTier() === "ESSENTIALS";
    if (!essentialsTier && !UserRoles.isOrgAdmin(User.get())) {
      $location.path('#');
    }
    if (!hasInteractions && $routeParams.demo !== 'true') {
      $location.search('demo', 'true');
    } else if (hasInteractions) {
      $location.search('demo', null);
    }
    $scope.essentialsTier = essentialsTier;
    demo = $routeParams.demo === 'true';
    Demo.setDemoMode(false);
    $scope.startDemo = Demo.startDemo.bind(Demo);

    //set up the nav dashboard correctly on page load
    $scope.$emit("nav:change", id);
    $timeout(function () {
      var name = 'Essentials LRS';
      var link = demo ? '#/essentials?demo=true' : '#/essentials';
      $rootScope.$broadcast(wsEventNames.dashboard.selected, {
        name: name,
        link: link
      });
    }, 500);
    $scope.statementCount = 0;
    $scope.history = [];
    $scope.activeFilters = [];
    $scope.hasData = null;
    $scope.showDataLimits = essentialsTier;
    $scope.filter = {
      dateFilter: {
        dateType: "custom"
      }
    };
    $scope.setDateFilter = function setDateFilter(f) {
      $scope.currentDateFilter = f;
      $scope.previousPeriod = Utils.getPreviousPeriod(f);
      $scope.lastYear = Utils.getLastYearPeriod(f);
      //todo: this should also update the compare to filter automatically

      $scope.filter.dateFilter.customDateFrom = f.start ? f.start.toISOString() : null;
      $scope.filter.dateFilter.customDateTo = f.end ? f.end.toISOString() : null;
      refreshPage();
    };
    $scope.dateFilters = Utils.getDateFilters();
    var updatePercentChange = function updatePercentChange() {
      $scope.statementCountChange = Utils.getPercentChange($scope.previousStatementCount, $scope.statementCount);
      $scope.activityCountChange = Utils.getPercentChange($scope.previousActivityCount, $scope.activityCount);
      $scope.peopleCountChange = Utils.getPercentChange($scope.previousPeopleCount, $scope.peopleCount);
      $scope.actionCountChange = Utils.getPercentChange($scope.previousActionCount, $scope.actionCount);
      $scope.resultCountChange = Utils.getPercentChange($scope.previousResultCount, $scope.resultCount);
    };
    $scope.setCompareToDateFilter = function (f) {
      if (!f.start && !f.end) {
        return;
      }
      $scope.compareTo = f.name;
      var compareToFilter = {
        dateFilter: {
          dateType: "custom",
          customDateFrom: f.start ? f.start.toISOString() : null,
          customDateTo: f.end ? f.end.toISOString() : null
        }
      };
      Utils.getStatementCount(compareToFilter).then(function (response) {
        var data = response.data;
        $scope.previousStatementCount = data.count;
        if ($scope.previousStatementCount > 0) {
          Utils.fetchData(compareToFilter, true).then(function (fetchResponse) {
            var data = fetchResponse.data;
            $scope.previousActivityCount = data.results[1].result.count;
            $scope.previousPeopleCount = data.results[2].result.count;
            $scope.previousActionCount = data.results[3].result.count;
            $scope.previousResultCount = data.results[4].result.count;
            updatePercentChange();
          });
        }
      });
    };
    var initialLoad = true,
      tryAllData = true;
    Utils.getActivityProviders().then(function (r) {
      $scope.dataSourceCount = r.count;
    });
    var refreshPage = function refreshPage() {
      $scope.hasData = null;
      Utils.getStatementCount($scope.filter).then(function (response) {
        var data = response.data;
        $scope.statementCount = data.count;
        if ($scope.statementCount > 0) {
          Utils.fetchData($scope.filter).then(function (fetchResponse) {
            var data = fetchResponse.data;
            var counts = Utils.getCounts(data),
              lists = Utils.getLists(data);
            $scope.dataSourcesPieChart = Utils.getPieChart(lists.dataSources);
            if (initialLoad) {
              $scope.dataSources = lists.dataSources;
              if ($scope.dataSources.length > 1) {
                $scope.dataSources.unshift({
                  name: 'All data sources',
                  id: 'ALL'
                });
              }
              $scope.currentDataSource = $scope.dataSources[0];
              initialLoad = false;
            }
            $scope.activities = lists.activities;
            $scope.activityCount = counts.activities;
            $scope.people = lists.people;
            $scope.peopleCount = counts.people;
            $scope.actions = lists.actions;
            $scope.actionCount = counts.actions;
            $scope.results = lists.results;
            $scope.resultCount = counts.results;
            $scope.interactions = _.first(data.results[5].result, 5);

            //multiple series here
            $scope.dataSourcesLineChart = Utils.getLineChart(data.results[6].result.data, {
              name: 'Data sources',
              aggregationIndex: 0,
              include: _.pluck(lists.dataSources, 'id')
            });
            $scope.activitiesLineChart = Utils.getLineChart(data.results[7].result.data, {
              name: 'Activities',
              aggregationIndex: 0
            });
            $scope.peopleLineChart = Utils.getLineChart(data.results[7].result.data, {
              name: 'People',
              aggregationIndex: 1
            });
            $scope.actionsLineChart = Utils.getLineChart(data.results[7].result.data, {
              name: 'Actions',
              aggregationIndex: 2
            });
            $scope.resultsLineChart = Utils.getLineChart(data.results[7].result.data, {
              name: 'Results',
              aggregationIndex: 3
            });
            $scope.setCompareToDateFilter($scope.previousPeriod);
            $scope.hasData = true;
          });
        } else {
          $scope.hasData = false;
          if (initialLoad && tryAllData) {
            tryAllData = false;
            $scope.setDateFilter($scope.dateFilters[0]);
          }
        }
      });
    };
    $scope.setDateFilter($scope.dateFilters[7]);
    $scope.selectDataSource = function selectDataSource(d) {
      $scope.currentDataSource = d;
      $scope.filter.equals = null;
      $scope.filter = _.extend($scope.filter, Utils.createDataSourceFilter(d));
      refreshPage();
    };
    $scope.sortOptions = [{
      name: 'Interactions',
      value: "-measure[0].value",
      i: 0
    }, {
      name: 'Unique Activities',
      value: "-measure[2].value",
      i: 2
    }, {
      name: 'People',
      value: "-measure[1].value",
      i: 1
    }, {
      name: 'Newest',
      value: "-measure[3].value",
      i: 3
    }, {
      name: 'Oldest',
      value: "measure[3].value",
      i: 3
    }];
    $scope.sort = {
      activity: $scope.sortOptions[0],
      person: $scope.sortOptions[0],
      action: $scope.sortOptions[0],
      result: $scope.sortOptions[0]
    };
    $scope.sortEntity = function (entity, sort) {
      $scope.sort[entity] = sort;
      Utils.fetchEntityData(entity, $scope.filter, $scope.sort[entity].value, 5).then(function (response) {
        var data = response.data;
        $scope[pluralize(entity)] = Utils.getList(data.results[0].result.data, entity, $scope.sort[entity].i);
      });
    };
    $scope.clearHistory = function () {
      $scope.history = [];
      $scope.activeFilters = [];
      delete $scope.entity;
      $scope.filter = {
        dateFilter: {
          dateType: "custom",
          customDateFrom: $scope.currentDateFilter.start,
          customDateTo: $scope.currentDateFilter.end
        }
      };
    };
    $scope.updateHistory = function (page) {
      $scope.history.push(page);
    };
    $scope.back = function () {
      //remove the current page
      $scope.history.pop();
      var prev = $scope.history.pop();
      $scope.entity = prev.entity;
      $scope.filter = prev.filter;
      $scope.activeFilters = prev.activeFilters;

      // If object has a type it's a single entity
      if ($scope.entity.type) {
        $scope.openSingleModal($scope.entity, true);
      } else if ($scope.entity === 'interactions') {
        $scope.openInteractionsModal(true);
      } else {
        $scope.openListModal($scope.entity, true);
      }
    };
    var updateActiveFilters = function updateActiveFilters(backButton) {
      //get the last filter we applied
      var lastFilter = $scope.filter;
      //if we have been to other modals and we are not going back to a previous one
      if ($scope.history.length > 0 && !backButton) {
        //get the last modal's filter
        lastFilter = angular.copy($scope.history[$scope.history.length - 1]).filter;
      }
      //add the correct entity to the filter
      $scope.filter = Utils.addEntityToFilter(lastFilter, $scope.entity);
      //also add that entity to the active filters for display
      if (!backButton) {
        $scope.activeFilters.push($scope.entity);
      }
    };
    $scope.openListModal = function openListModal(entity, backButton) {
      if ($scope.entity) {
        updateActiveFilters(backButton);
      }
      $scope.entity = entity;
      $uibModal.open({
        templateUrl: 'modules/app/essentials/listModal.html',
        controller: id + '.ListModalCtrl',
        backdrop: 'static',
        scope: $scope
      });
    };
    $scope.openInteractionsModal = function (backButton) {
      if ($scope.entity) {
        updateActiveFilters(backButton);
      }
      $uibModal.open({
        templateUrl: 'modules/app/essentials/interactionsModal.html',
        controller: id + '.InteractionsModalCtrl',
        backdrop: 'static',
        scope: $scope
      });
    };
    $scope.openSingleModal = function openSingleModal(entity, backButton) {
      if (entity.values) {
        // Translate entity object from the object we get from list modals
        $scope.entity = {
          "title": entity.values[0].label + (entity.values[1] ? ' + ' + entity.values[1].label : ''),
          "id": entity.values[0].value + (entity.values[1] ? ' + ' + entity.values[1].value : ''),
          "type": entity.type
        };
      } else {
        $scope.entity = entity;
      }
      if ($scope.history.length > 0 && !backButton) {
        $scope.filter = angular.copy($scope.history[$scope.history.length - 1]).filter;
      }
      if (entity.type === "person" || entity.type === "people") {
        $uibModal.open({
          templateUrl: 'modules/app/essentials/personDetails.html',
          controller: id + '.PersonDetailsCtrl',
          backdrop: 'static',
          scope: $scope
        });
      } else {
        $uibModal.open({
          templateUrl: 'modules/app/essentials/activityDetails.html',
          controller: id + '.ActivityDetailsCtrl',
          backdrop: 'static',
          scope: $scope
        });
      }
    };
    $scope.emailDeveloper = function () {
      $uibModal.open({
        templateUrl: 'modules/app/essentials/emailDeveloperModal.html',
        controller: id + '.EmailDeveloperCtrl',
        backdrop: 'static',
        scope: $scope
      });
    };
    $scope.typeahead = function (query) {
      return $http.get(Api.url("/essentials/search", false, true), {
        params: {
          "searchTerm": query,
          "_limit": 10,
          "demo": demo
        }
      }).then(function (result) {
        var searchResults = result.data;
        var combinedResults = [];
        if (searchResults.activities.length > 0) {
          combinedResults.push({
            'type': 'divider',
            'title': 'Activities'
          });
          combinedResults = combinedResults.concat(searchResults.activities);
        }
        if (searchResults.actions.length > 0) {
          combinedResults.push({
            'type': 'divider',
            'title': 'Actions'
          });
          combinedResults = combinedResults.concat(searchResults.actions);
        }
        if (searchResults.people.length > 0) {
          combinedResults.push({
            'type': 'divider',
            'title': 'People'
          });
          combinedResults = combinedResults.concat(searchResults.people);
        }
        return combinedResults;
      });
    };
    $scope.onTypeaheadSelect = function onTypeaheadSelect($item) {
      $scope.openSingleModal($item);
    };
  }]).controller(id + '.ListModalCtrl', ['$scope', '$uibModalInstance', id + '.Utils', 'wsEventNames', '$timeout', '$http', 'Api', function ($scope, $uibModalInstance, Utils, wsEventNames, $timeout, $http, Api) {
    //translate the parent scope's sort to one we use here
    $scope.sort = ($scope.sort[$scope.entity] ? "-" : "") + "measure[0].value";
    $scope.hasData = null;
    $scope.noDataMsg = "No " + pluralize($scope.entity) + " found for this filter";

    //get a copy of the filter so we don't modify the parent's scope filter
    $scope.filter = angular.copy($scope.filter);
    $scope.filter.name = $scope.filter.name || $scope.currentDateFilter.name || $scope.currentDateFilter;
    $scope.currentDateFilter = $scope.filter;
    var updateHistory = function updateHistory() {
      $scope.updateHistory(angular.copy({
        entity: $scope.entity,
        filter: $scope.filter,
        activeFilters: $scope.activeFilters
      }));
    };
    $scope.dateFilters = Utils.getDateFilters(angular.copy($scope.filter));
    updateHistory();
    $scope.setDateFilter = function setDateFilter(f) {
      $scope.currentDateFilter = f;
      $scope.filter.name = f.name;
      $scope.filter.dateFilter.customDateFrom = f.start ? f.start.toISOString() : null;
      $scope.filter.dateFilter.customDateTo = f.end ? f.end.toISOString() : null;
      updateHistory();
      $scope.hasData = null;
      $scope.$broadcast(wsEventNames.pager.setPage, 1);
    };
    $scope.totalDays = moment.utc($scope.filter.dateFilter.customDateTo).diff(moment.utc($scope.filter.dateFilter.customDateFrom), 'days');
    $scope.setSort = function (sort) {
      $scope.sort = $scope.sort === "-" + sort ? sort : "-" + sort;
      $scope.$broadcast(wsEventNames.pager.setPage, 1);
    };
    $scope.getTypeahead = function (search) {
      return $http.get(Api.url("/essentials/search", false, true), {
        params: {
          "searchTerm": search,
          "entityType": $scope.entity,
          "demo": demo
        }
      }).then(function (data) {
        return data.data[pluralize($scope.entity)];
      });
    };
    $scope.fetchPage = function (offset, limit) {
      offset = offset || 0;
      limit = limit || 10;
      return Utils.fetchEntityData($scope.entity, $scope.filter, $scope.sort, limit, offset).then(function (response) {
        var data = response.data;
        var results = data.results[0].result;
        $scope.count = results.count;
        $scope.hasData = $scope.count > 0;
        $scope.totalHits = data.totalHits;
        $scope.entities = results.data;
        _.each($scope.entities, function (e) {
          e.type = $scope.entity;
        });
        return results;
      });
    };
    $timeout(function () {
      $scope.$broadcast(wsEventNames.pager.setPage, 1);
    }, 0);
    $scope.searchSelected = function (item) {
      $scope.close();
      $scope.openSingleModal(item);
    };
    $scope.close = function (clearHistory) {
      if (clearHistory) {
        $scope.clearHistory();
      }
      $uibModalInstance.dismiss();
    };
  }]).controller(id + '.InteractionsModalCtrl', ['$scope', '$uibModalInstance', id + '.Utils', 'wsEventNames', '$timeout', function ($scope, $uibModalInstance, Utils, wsEventNames, $timeout) {
    $scope.interactions = [];
    $scope.filter = angular.copy($scope.filter);
    $scope.filter.name = $scope.filter.name || $scope.currentDateFilter.name || $scope.currentDateFilter;
    $scope.currentDateFilter = $scope.filter;
    $scope.noDataMsg = "No interactions found for this filter";
    $scope.hasInteractions = null;
    var updateHistory = function updateHistory() {
      $scope.updateHistory(angular.copy({
        entity: 'interactions',
        filter: $scope.filter,
        activeFilters: $scope.activeFilters
      }));
    };
    updateHistory();
    $scope.dateFilters = Utils.getDateFilters(angular.copy($scope.filter));
    $scope.setDateFilter = function setDateFilter(f) {
      $scope.currentDateFilter = f;
      $scope.filter.name = f.name;
      $scope.filter.dateFilter.customDateFrom = f.start ? f.start.toISOString() : null;
      $scope.filter.dateFilter.customDateTo = f.end ? f.end.toISOString() : null;
      updateHistory();
      $scope.$broadcast(wsEventNames.pager.setPage, 1);
    };
    $scope.fetchPage = function (offset, limit) {
      offset = offset || 0;
      limit = limit || 10;
      $scope.interactions = [];
      $scope.hasInteractions = null;
      return Utils.fetchEntityData('interactions', $scope.filter, null, limit, offset).then(function (response) {
        var data = response.data;
        var results = data.results[0].result;
        $scope.interactions = results;
        $scope.interactionCount = data.totalHits;
        $scope.hasInteractions = $scope.interactionCount > 0;
        results.count = data.totalHits;
        _.each($scope.entities, function (e) {
          e.type = "interactions";
        });
        return results;
      }, function () {
        $scope.hasInteractions = false;
      });
    };
    $timeout(function () {
      $scope.$broadcast(wsEventNames.pager.setPage, 1);
    }, 0);
    $scope.close = function (clearHistory) {
      if (clearHistory) {
        $scope.clearHistory();
      }
      $uibModalInstance.dismiss();
    };
  }]).controller(id + '.PersonDetailsCtrl', ['$scope', '$uibModalInstance', id + '.Utils', '$q', '$http', 'Api', 'TinCanJS', function ($scope, $uibModalInstance, Utils, $q, $http, Api, TinCanJS) {
    $scope.hasData = null;
    $scope.noDataMsg = "No activity found for this filter";

    //get a copy of the filter so we don't modify the parent's scope filter
    $scope.filter = angular.copy($scope.filter);
    $scope.filter.name = $scope.filter.name || $scope.currentDateFilter.name || $scope.currentDateFilter;
    $scope.currentDateFilter = $scope.filter;
    var updateHistory = function updateHistory() {
      $scope.history.push(angular.copy({
        entity: $scope.entity,
        filter: $scope.filter,
        activeFilters: $scope.activeFilters
      }));
    };
    updateHistory();
    var filter = angular.copy($scope.filter);
    if (!filter.personIds) {
      filter.personIds = [];
    }
    filter.personIds.push($scope.entity.id);
    $scope.dateFilters = Utils.getDateFilters(filter);
    $scope.setDateFilter = function setDateFilter(f) {
      $scope.currentDateFilter = f;
      $scope.filter.name = f.name;
      $scope.filter.dateFilter.customDateFrom = f.start ? f.start.toISOString() : null;
      $scope.filter.dateFilter.customDateTo = f.end ? f.end.toISOString() : null;
      updateHistory();
      $scope.hasData = null;
      $scope.loadPersonData();
    };

    // Indexes
    var STMT_COUNT = 0;
    var PEOPLE_COUNT = 1;
    var ACTIVITY_COUNT = 2;
    var ACTION_COUNT = 3;
    var RESULT_COUNT = 4;
    var TOTAL_DURATION = 5;
    var AVG_DURATION = 6;
    var COMPLETION_COUNT = 7;
    var SUCCESS_COUNT = 8;
    var AVG_SCORE = 9;
    if (!$scope.entity.hasOwnProperty("dbId")) {
      $scope.entity.dbId = $scope.entity.id;
    }
    $scope.loadPersonData = function loadPersonData() {
      $q.all([Utils.getPersonDetails($scope.filter, $scope.entity.dbId), Utils.getPersonDetails($scope.filter), $http.get(Api.url("/interactions/preview"), {
        params: {
          config: {
            "filter": {
              "personIds": [$scope.entity.dbId]
            }
          },
          limit: 1,
          ascending: true,
          demo: demo
        }
      }), $http.get(Api.url("/interactions/preview"), {
        params: {
          config: {
            "filter": {
              "personIds": [$scope.entity.dbId]
            }
          },
          limit: 1,
          ascending: false,
          demo: demo
        }
      })]).then(function (responses) {
        var personResponse = responses[0].data;
        var allResponse = responses[1].data;
        $scope.firstStatement = TinCanJS.getDecoratedStatements(responses[2].data.results[0].result)[0] || {};
        $scope.lastStatement = TinCanJS.getDecoratedStatements(responses[3].data.results[0].result)[0] || {};
        $scope.firstVerb = $scope.firstStatement.verbName;
        $scope.firstTimestamp = $scope.firstStatement.timestamp;
        $scope.lastVerb = $scope.lastStatement.verbName;
        $scope.lastTimestamp = $scope.lastStatement.timestamp;
        $scope.lastActivity = $scope.lastStatement.objectName;
        $scope.lastActivityEntity = {
          "type": "activity",
          "id": $scope.lastStatement.object.id,
          "title": $scope.lastActivity
        };
        if (personResponse.results[0].result.data.length > 0) {
          var personData = personResponse.results[0].result.data[0];
          var personStats = personResponse.results[0].result.stats;
          $scope.personData = {
            "interactions": personData.aggregations[STMT_COUNT].value,
            "activities": personData.aggregations[ACTIVITY_COUNT].value,
            "actions": personData.aggregations[ACTION_COUNT].value,
            "results": personData.aggregations[RESULT_COUNT].value,
            "totalDuration": personData.aggregations[TOTAL_DURATION].value,
            "avgDuration": personData.aggregations[AVG_DURATION].value,
            "completions": personData.aggregations[COMPLETION_COUNT].value,
            "successes": personData.aggregations[SUCCESS_COUNT].value,
            "topScore": personStats[AVG_SCORE].max,
            "lowScore": personStats[AVG_SCORE].min,
            "avgScore": personData.aggregations[AVG_SCORE].value
          };
        } else {
          // zero out this person, no data
          $scope.personData = {
            "interactions": 0,
            "activities": 0,
            "actions": 0,
            "results": 0,
            "totalDuration": 0,
            "avgDuration": 0,
            "completions": 0,
            "successes": 0,
            "topScore": null,
            "lowScore": null,
            "avgScore": null
          };
        }
        if (allResponse.results[0].result.data.length > 0) {
          var allData = allResponse.results[0].result.data[0];
          var allStats = allResponse.results[0].result.stats;
          var peopleCount = allData.aggregations[PEOPLE_COUNT].value;
          $scope.allData = {
            "interactions": allData.aggregations[STMT_COUNT].value / peopleCount,
            "activities": allData.aggregations[ACTIVITY_COUNT].value / peopleCount,
            "actions": allData.aggregations[ACTION_COUNT].value / peopleCount,
            "results": allData.aggregations[RESULT_COUNT].value / peopleCount,
            "totalDuration": allData.aggregations[TOTAL_DURATION].value / peopleCount,
            "avgDuration": allData.aggregations[AVG_DURATION].value,
            "completions": allData.aggregations[COMPLETION_COUNT].value / peopleCount,
            "successes": allData.aggregations[SUCCESS_COUNT].value / peopleCount,
            "topScore": allStats[AVG_SCORE].max,
            "lowScore": allStats[AVG_SCORE].min,
            "avgScore": allData.aggregations[AVG_SCORE].value
          };
          $scope.changes = {
            "interactions": Utils.getPercentChange($scope.allData.interactions, $scope.personData.interactions),
            "activities": Utils.getPercentChange($scope.allData.activities, $scope.personData.activities),
            "actions": Utils.getPercentChange($scope.allData.actions, $scope.personData.actions),
            "results": Utils.getPercentChange($scope.allData.results, $scope.personData.results),
            "totalDuration": Utils.getPercentChange($scope.allData.totalDuration, $scope.personData.totalDuration),
            "avgDuration": Utils.getPercentChange($scope.allData.avgDuration, $scope.personData.avgDuration),
            "completions": Utils.getPercentChange($scope.allData.completions, $scope.personData.completions),
            "successes": Utils.getPercentChange($scope.allData.successes, $scope.personData.successes),
            "topScore": Utils.getPercentChange($scope.allData.topScore, $scope.personData.topScore),
            "lowScore": Utils.getPercentChange($scope.allData.lowScore, $scope.personData.lowScore),
            "avgScore": Utils.getPercentChange($scope.allData.avgScore, $scope.personData.avgScore)
          };
          $scope.hasData = true;
        } else {
          $scope.hasData = false;
        }
        $scope.singlePersonActivityChart = Utils.getLineChart(personResponse.results[1].result.data, {
          name: 'Activities',
          aggregationIndex: 0
        });
        var allPeopleActivityChart = Utils.getLineChart(allResponse.results[1].result.data, {
          name: 'Activities',
          aggregationIndex: 0
        });
        _.each(allPeopleActivityChart.series[0].data, function (point) {
          // Take the "everyone" numbers and divide by people count to get the average per person
          point.y = point.y / peopleCount;

          // Fill in corresponding date points in the single series with 0 if they don't exist
          if (!Utils.pointWithDateExists($scope.singlePersonActivityChart.series[0].data, {
            date: point.x
          })) {
            var newPoint = _.clone(point);
            newPoint.y = 0;
            $scope.singlePersonActivityChart.series[0].data.push(newPoint);
          }
        });

        //re-sort data so highcharts stays happy
        $scope.singlePersonActivityChart.series[0].data = _.sortBy($scope.singlePersonActivityChart.series[0].data, 'x');

        // Now append the "everybody" series to the first chart
        $scope.singlePersonActivityChart.series.push(allPeopleActivityChart.series[0]);
        $scope.singlePersonActivityChart.legend.enabled = true;
        $scope.singlePersonActivityChart.series[0].name = $scope.entity.title + " - Activities";
        $scope.singlePersonActivityChart.series[1].name = "Everyone - Activities";
      });
    };
    $scope.loadPersonData();
    $scope.close = function (clearHistory) {
      if (clearHistory) {
        $scope.clearHistory();
      }
      $uibModalInstance.dismiss();
    };
  }]).controller(id + '.ActivityDetailsCtrl', ['$scope', '$uibModalInstance', id + '.Utils', '$q', '$http', 'Api', 'TinCanJS', function ($scope, $uibModalInstance, Utils, $q, $http, Api, TinCanJS) {
    $scope.hasData = null;
    $scope.noDataMsg = "No activity found for this filter";

    //get a copy of the filter so we don't modify the parent's scope filter
    $scope.filter = angular.copy($scope.filter);
    $scope.filter.name = $scope.filter.name || $scope.currentDateFilter.name || $scope.currentDateFilter;
    $scope.currentDateFilter = $scope.filter;
    var updateHistory = function updateHistory() {
      $scope.history.push(angular.copy({
        entity: $scope.entity,
        filter: $scope.filter,
        activeFilters: $scope.activeFilters
      }));
    };
    updateHistory();
    var filter = angular.copy($scope.filter);
    if ($scope.entity.type === "actions") {
      var ids = $scope.entity.id.split(" + ");
      if (ids.length > 1) {
        if (!filter.activityIds) {
          filter.activityIds = {
            ids: []
          };
        }
        filter.activityIds.ids.push(ids[1]);
        if (!filter.verbIds) {
          filter.verbIds = {
            ids: []
          };
        }
        filter.verbIds.ids.push(ids[0]);
      }
    } else {
      if (!filter.activityIds) {
        filter.activityIds = {
          ids: []
        };
      }
      if ($scope.entity.id) {
        filter.activityIds.ids.push($scope.entity.id);
      }
    }
    $scope.dateFilters = Utils.getDateFilters(filter);
    $scope.setDateFilter = function setDateFilter(f) {
      $scope.currentDateFilter = f;
      $scope.filter.name = f.name;
      $scope.filter.dateFilter.customDateFrom = f.start ? f.start.toISOString() : null;
      $scope.filter.dateFilter.customDateTo = f.end ? f.end.toISOString() : null;
      updateHistory();
      $scope.hasData = null;
      $scope.loadActivityData();
    };

    // Indexes
    var PEOPLE_COUNT = 0;
    var INTERACTION_COUNT = 1;
    var TOTAL_DURATION = 2;
    var AVG_DURATION = 3;
    var COMPLETION_COUNT = 4;
    var SUCCESS_COUNT = 5;
    var AVG_SCORE = 6;
    $scope.loadActivityData = function loadActivityData() {
      if (!$scope.entity.hasOwnProperty("dbId")) {
        $scope.entity.dbId = $scope.entity.id;
      }
      var interactionFilter;
      if ($scope.entity.id.toString().indexOf("+") > -1) {
        var actionPair = $scope.entity.id.split('+');
        if (actionPair.length > 1) {
          interactionFilter = {
            "filter": {
              "verbIds": {
                "ids": [actionPair[0].trim()]
              },
              "activityIds": {
                "ids": [actionPair[1].trim()]
              }
            }
          };
        }
      } else {
        if ($scope.entity.id) {
          interactionFilter = {
            "filter": {
              "activityIds": {
                "ids": [$scope.entity.id]
              }
            }
          };
        }
      }
      $q.all([Utils.getActivityDetails($scope.filter, $scope.entity.id, $scope.entity.type), Utils.getActivityDetails($scope.filter), $http.get(Api.url("/interactions/preview"), {
        params: {
          config: interactionFilter,
          limit: 1,
          ascending: true,
          demo: demo
        }
      }), $http.get(Api.url("/interactions/preview"), {
        params: {
          config: interactionFilter,
          limit: 1,
          ascending: false,
          demo: demo
        }
      }), $http.get(Api.url("/essentials/activity-count"), {
        params: {
          demo: demo
        }
      })]).then(function (responses) {
        var activityResponse = responses[0].data;
        var allResponse = responses[1].data;
        $scope.firstStatement = TinCanJS.getDecoratedStatements(responses[2].data.results[0].result)[0];
        $scope.lastStatement = TinCanJS.getDecoratedStatements(responses[3].data.results[0].result)[0];
        $scope.firstVerb = $scope.firstStatement.verbName;
        $scope.firstTimestamp = $scope.firstStatement.timestamp;
        $scope.lastVerb = $scope.lastStatement.verbName;
        $scope.lastTimestamp = $scope.lastStatement.timestamp;
        $scope.lastActivity = $scope.lastStatement.objectName;
        if (activityResponse.results[0].result.data.length > 0) {
          var activityData = activityResponse.results[0].result.data[0];
          var activityStats = activityResponse.results[0].result.stats;
          $scope.activityData = {
            "people": activityData.aggregations[PEOPLE_COUNT].value,
            "interactions": activityData.aggregations[INTERACTION_COUNT].value,
            "totalDuration": activityData.aggregations[TOTAL_DURATION].value,
            "avgDuration": activityData.aggregations[AVG_DURATION].value,
            "completions": activityData.aggregations[COMPLETION_COUNT].value,
            "successes": activityData.aggregations[SUCCESS_COUNT].value,
            "topScore": activityStats[AVG_SCORE].max,
            "lowScore": activityStats[AVG_SCORE].min,
            "avgScore": activityData.aggregations[AVG_SCORE].value
          };
        } else {
          // zero out this person, no data
          $scope.activityData = {
            "interactions": 0,
            "activities": 0,
            "actions": 0,
            "results": 0,
            "totalDuration": 0,
            "avgDuration": 0,
            "completions": 0,
            "successes": 0,
            "topScore": null,
            "lowScore": null,
            "avgScore": null
          };
        }
        if (allResponse.results[0].result.data.length > 0) {
          var allData = allResponse.results[0].result.data[0];
          var allStats = allResponse.results[0].result.stats;
          $scope.allData = {
            "people": allData.aggregations[PEOPLE_COUNT].value,
            "interactions": allData.aggregations[INTERACTION_COUNT].value / $scope.activityCount,
            "totalDuration": allData.aggregations[TOTAL_DURATION].value / $scope.activityCount,
            "avgDuration": allData.aggregations[AVG_DURATION].value,
            "completions": allData.aggregations[COMPLETION_COUNT].value / $scope.activityCount,
            "successes": allData.aggregations[SUCCESS_COUNT].value / $scope.activityCount,
            "topScore": allStats[AVG_SCORE].max,
            "lowScore": allStats[AVG_SCORE].min,
            "avgScore": allData.aggregations[AVG_SCORE].value
          };
          $scope.changes = {
            "people": Utils.getPercentChange($scope.allData.people, $scope.activityData.people),
            "interactions": Utils.getPercentChange($scope.allData.interactions, $scope.activityData.interactions),
            "totalDuration": Utils.getPercentChange($scope.allData.totalDuration, $scope.activityData.totalDuration),
            "avgDuration": Utils.getPercentChange($scope.allData.avgDuration, $scope.activityData.avgDuration),
            "completions": Utils.getPercentChange($scope.allData.completions, $scope.activityData.completions),
            "successes": Utils.getPercentChange($scope.allData.successes, $scope.activityData.successes),
            "topScore": Utils.getPercentChange($scope.allData.topScore, $scope.activityData.topScore),
            "lowScore": Utils.getPercentChange($scope.allData.lowScore, $scope.activityData.lowScore),
            "avgScore": Utils.getPercentChange($scope.allData.avgScore, $scope.activityData.avgScore)
          };
          $scope.hasData = true;
        } else {
          $scope.hasData = false;
        }
        $scope.chart = Utils.getLineChart(activityResponse.results[1].result.data, {
          name: 'Activities',
          aggregationIndex: 1
        });
        var allChart = Utils.getLineChart(allResponse.results[1].result.data, {
          name: 'Activities',
          aggregationIndex: 1
        });
        _.each(allChart.series[0].data, function (point) {
          // Take the "everyone" numbers and divide by people count to get the average per person
          point.y = point.y / $scope.activityCount;

          // Fill in corresponding date points in the single series with 0 if they don't exist
          if (!Utils.pointWithDateExists($scope.chart.series[0].data, {
            date: point.x
          })) {
            var newPoint = _.clone(point);
            newPoint.y = 0;
            $scope.chart.series[0].data.push(newPoint);
          }
        });

        //re-sort data so highcharts stays happy
        $scope.chart.series[0].data = _.sortBy($scope.chart.series[0].data, 'x');

        // Now append the "everybody" series to the first chart
        $scope.chart.series.push(allChart.series[0]);
        $scope.chart.legend.enabled = true;
        $scope.chart.series[0].name = "This " + pluralize($scope.entity.type, 1) + " - People";
        $scope.chart.series[1].name = "All " + pluralize($scope.entity.type) + " - People";
      });
    };
    $scope.loadActivityData();
    $scope.close = function (clearHistory) {
      if (clearHistory) {
        $scope.clearHistory();
      }
      $uibModalInstance.dismiss();
    };
  }]).controller(id + '.EmailDeveloperCtrl', ['$scope', 'Validation', '$http', 'Api', '$uibModalInstance', '$window', 'Analytics', 'Logger', function ($scope, Validation, $http, Api, $uibModalInstance, $window, Analytics, Logger) {
    $scope.close = function () {
      $uibModalInstance.dismiss();
    };
    $scope.helpLink = "https://watershedlrs.zendesk.com/hc?environment=" + $window.location.hostname;
    $scope.helpClicked = Analytics.helpLinkClicked;
    $scope.send = function () {
      $scope.formErrors = Validation.validate({
        "developer emails": {
          "rules": {
            "required": true,
            "multipleEmail": true
          },
          "value": $scope.developerEmails
        }
      });
      if ($scope.formErrors !== null) {
        return;
      }
      $http.post(Api.url("/essentials/email", false, true), $scope.developerEmails).then(function () {
        $uibModalInstance.dismiss();
      }, function (e) {
        //something went wrong, display the help text and log the error
        $scope.error = true;
        Logger.warn(e);
      });
    };
  }]);
})();
